/* ==========================================================================
   The Ashcombe House — theme.js
   Vanilla, dependency-free. Everything is progressively enhanced.
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var cfg = window.theme || { routes: {}, strings: {}, moneyFormat: '${{amount}}' };

  /* Money formatting ------------------------------------------------------ */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || cfg.moneyFormat || '${{amount}}';
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = formatString.match(placeholderRegex);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }
  cfg.formatMoney = formatMoney;

  /* Drawers ---------------------------------------------------------------- */
  var drawers = {};
  var openStack = [];

  function Drawer(el) {
    this.el = el;
    this.name = el.getAttribute('data-drawer');
    this.trigger = null;
  }
  Drawer.prototype.open = function (trigger) {
    var self = this;
    openStack.forEach(function (d) { if (d !== self) d.close(); });
    this.trigger = trigger || null;
    this.el.classList.add('is-open');
    this.el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    openStack.push(this);
    var focusable = this.el.querySelector('input:not([type=hidden]), button:not([data-drawer-close]), a, [tabindex]');
    setTimeout(function () { (focusable || self.el.querySelector('[data-drawer-close]') || self.el).focus({ preventScroll: true }); }, 60);
  };
  Drawer.prototype.close = function () {
    this.el.classList.remove('is-open');
    this.el.setAttribute('aria-hidden', 'true');
    openStack = openStack.filter(function (d) { return d !== this; }, this);
    if (openStack.length === 0) document.body.classList.remove('drawer-open');
    if (this.trigger && typeof this.trigger.focus === 'function') this.trigger.focus({ preventScroll: true });
    this.trigger = null;
  };

  function registerDrawers() {
    $$('[data-drawer]').forEach(function (el) {
      var name = el.getAttribute('data-drawer');
      if (!drawers[name]) drawers[name] = new Drawer(el);
      else drawers[name].el = el;
    });
  }
  registerDrawers();
  cfg.drawers = drawers;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var name = opener.getAttribute('data-drawer-open');
      if (drawers[name]) { e.preventDefault(); drawers[name].open(opener); }
      return;
    }
    var cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle && cfg.cartType === 'drawer' && drawers.cart) {
      e.preventDefault(); drawers.cart.open(cartToggle); return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      var drawerEl = closer.closest('[data-drawer]');
      if (drawerEl && drawers[drawerEl.getAttribute('data-drawer')]) drawers[drawerEl.getAttribute('data-drawer')].close();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openStack.length) openStack[openStack.length - 1].close();
  });

  /* Header ----------------------------------------------------------------- */
  var header = $('[data-header]');
  if (header) {
    var setHeaderHeight = function () {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Mobile submenu toggles */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-submenu-toggle]');
    if (!toggle) return;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    var sub = toggle.nextElementSibling;
    if (sub) sub.hidden = expanded;
  });

  /* Announcement bar rotation */
  $$('[data-announcement-bar][data-autoplay]').forEach(function (bar) {
    var slides = $$('.announcement-bar__slide', bar);
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, parseInt(bar.getAttribute('data-autoplay'), 10) || 5000);
  });

  /* Quantity buttons -------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('[data-qty-input]');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var val = parseInt(input.value || '0', 10);
    val = btn.hasAttribute('data-qty-plus') ? val + 1 : Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart -------------------------------------------------------------------- */
  var cart = {
    sectionIds: function () {
      var ids = ['cart-drawer'];
      var page = $('[data-cart-page]');
      if (page) ids.push(page.getAttribute('data-section-id'));
      return ids;
    },
    request: function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (data) { if (!r.ok) throw data; return data; }); });
    },
    add: function (formData) {
      formData.append('sections', this.sectionIds().join(','));
      formData.append('sections_url', window.location.pathname);
      return fetch(cfg.routes.cartAdd + '.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw data; return data; }); });
    },
    change: function (line, quantity) {
      return this.request(cfg.routes.cartChange + '.js', { line: line, quantity: quantity, sections: this.sectionIds(), sections_url: window.location.pathname });
    },
    updateNote: function (note) {
      return this.request(cfg.routes.cartUpdate + '.js', { note: note });
    },
    render: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (id === 'cart-drawer') {
          var fresh = doc.querySelector('[data-cart-drawer-content]');
          var current = $('#CartDrawer [data-cart-drawer-content]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          var freshDrawer = doc.querySelector('[data-drawer="cart"]');
          if (freshDrawer) cart.setCount(freshDrawer.getAttribute('data-cart-count'));
        } else {
          var target = document.getElementById('shopify-section-' + id);
          var freshSection = doc.getElementById('shopify-section-' + id);
          if (target && freshSection) target.innerHTML = freshSection.innerHTML;
        }
      });
    },
    setCount: function (count) {
      count = parseInt(count, 10) || 0;
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
      });
    }
  };
  cfg.cart = cart;

  // Product forms (main product + quick add)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-to-cart]');
    var errorEl = form.querySelector('[data-form-error]');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    if (errorEl) errorEl.hidden = true;
    var formData = new FormData(form);
    cart.add(formData).then(function (data) {
      cart.render(data.sections);
      if (cfg.cartType === 'drawer' && drawers.cart) drawers.cart.open(btn);
      else window.location.href = cfg.routes.cart;
    }).catch(function (err) {
      var msg = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
      if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } else { alert(msg); }
    }).finally(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
    });
  });

  // Line changes (drawer + cart page)
  var changeTimer;
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input][data-line]');
    if (!input) return;
    clearTimeout(changeTimer);
    changeTimer = setTimeout(function () {
      var item = input.closest('.cart-item');
      if (item) item.classList.add('is-loading');
      cart.change(parseInt(input.getAttribute('data-line'), 10), parseInt(input.value, 10) || 0)
        .then(function (data) { cart.render(data.sections); })
        .catch(function () { if (item) item.classList.remove('is-loading'); });
    }, 250);
  });
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-remove-line]');
    if (!remove) return;
    e.preventDefault();
    var item = remove.closest('.cart-item');
    if (item) item.classList.add('is-loading');
    cart.change(parseInt(remove.getAttribute('data-remove-line'), 10), 0)
      .then(function (data) { cart.render(data.sections); })
      .catch(function () { if (item) item.classList.remove('is-loading'); });
  });
  var noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { cart.updateNote(note.value); }, 500);
  });

  /* Product: variant picker ------------------------------------------------- */
  $$('[data-product]').forEach(function (productEl) {
    var picker = $('[data-variant-picker]', productEl);
    var form = $('[data-product-form]', productEl);
    var gallery = $('[data-gallery]', productEl);
    if (!picker || !form) return;
    var variants;
    try { variants = JSON.parse($('[data-variants-json]', picker).textContent); } catch (err) { return; }
    var optionCount = $$('.variant-picker__group', picker).length;

    function selectedOptions() {
      var opts = [];
      for (var i = 0; i < optionCount; i++) {
        var checked = $('[data-option-input][data-option-index="' + i + '"]:checked', picker);
        var select = $('[data-option-select][data-option-index="' + i + '"]', picker);
        opts.push(checked ? checked.value : (select ? select.value : null));
      }
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function updateAvailabilityHints(opts) {
      $$('[data-option-input]', picker).forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        var test = opts.slice();
        test[idx] = input.value;
        var exists = variants.some(function (v) {
          return v.available && v.options.every(function (o, i) { return i === idx || i > idx ? true : o === test[i]; }) && v.options[idx] === input.value;
        });
        var label = input.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !exists);
      });
    }
    function update() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      var btn = $('[data-add-to-cart]', form);
      var btnText = $('[data-add-to-cart-text]', form);
      var idInput = $('[data-variant-id]', form);
      var priceEl = $('[data-price]', productEl);

      $$('.variant-picker__group', picker).forEach(function (group, i) {
        var lbl = $('[data-option-value-label]', group);
        if (lbl) lbl.textContent = opts[i] || '';
      });
      updateAvailabilityHints(opts);

      if (!variant) {
        if (btn) { btn.disabled = true; }
        if (btnText) btnText.textContent = cfg.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (btn) btn.disabled = !variant.available;
      if (btnText) btnText.textContent = variant.available ? cfg.strings.addToCart : cfg.strings.soldOut;
      if (priceEl) {
        var reg = $('[data-price-regular]', priceEl);
        var cmp = $('[data-price-compare]', priceEl);
        if (reg) reg.textContent = formatMoney(variant.price);
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = formatMoney(variant.compare_at_price); }
        priceEl.classList.toggle('price--on-sale', !!onSale);
        priceEl.classList.toggle('price--sold-out', !variant.available);
      }
      if (variant.featured_media && gallery) showMedia(gallery, variant.featured_media.id);
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    picker.addEventListener('change', update);
  });

  /* Product: gallery -------------------------------------------------------- */
  function showMedia(gallery, mediaId) {
    var list = $('[data-media-list]', gallery);
    var item = $('[data-media-id="' + mediaId + '"]', gallery);
    if (!list || !item) return;
    $$('.product__media-item', gallery).forEach(function (el) { el.classList.toggle('is-active', el === item); });
    $$('[data-thumb-for]', gallery).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb-for') === String(mediaId)); });
    var stacked = getComputedStyle(list).flexDirection === 'column';
    if (stacked) {
      item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } else {
      list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: 'smooth' });
    }
  }
  $$('[data-gallery]').forEach(function (gallery) {
    var list = $('[data-media-list]', gallery);
    if (!list) return;
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb-for]');
      if (thumb) showMedia(gallery, thumb.getAttribute('data-thumb-for'));
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio > 0.6) {
            var id = entry.target.getAttribute('data-media-id');
            $$('[data-thumb-for]', gallery).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb-for') === id); });
          }
        });
      }, { root: list, threshold: [0.6] });
      $$('.product__media-item', gallery).forEach(function (el) { io.observe(el); });
    }
  });

  /* Related products -------------------------------------------------------- */
  $$('[data-related-products]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-related-products]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* Collection sorting & filtering ----------------------------------------- */
  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-sort-select]');
    if (sort) { sort.form.submit(); return; }
  });
  $$('[data-filter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      // Remove empty inputs so the URL stays clean
      $$('input', form).forEach(function (input) {
        if ((input.type === 'number' || input.type === 'text') && input.value === '') input.disabled = true;
      });
    });
  });

  /* Share ------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share-button]');
    if (!btn) return;
    var url = btn.getAttribute('data-share-url') || window.location.href;
    var title = btn.getAttribute('data-share-title') || document.title;
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        var original = btn.textContent;
        btn.textContent = 'Link copied';
        setTimeout(function () { btn.textContent = original; }, 2000);
      });
    }
  });

  /* Customer: login / recover toggle, addresses ----------------------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-recover-toggle]');
    if (toggle) {
      e.preventDefault();
      var login = $('#LoginPanel'), recover = $('#RecoverPanel');
      if (login && recover) { login.hidden = !login.hidden; recover.hidden = !recover.hidden; }
    }
    var edit = e.target.closest('[data-address-edit]');
    if (edit) {
      var panel = document.getElementById('EditAddress-' + edit.getAttribute('data-address-edit'));
      if (panel) panel.hidden = !panel.hidden;
    }
    var del = e.target.closest('[data-address-delete]');
    if (del && !window.confirm(del.getAttribute('data-confirm') || 'Delete this address?')) e.preventDefault();
  });
  if (window.location.hash === '#recover') {
    var l = $('#LoginPanel'), r = $('#RecoverPanel');
    if (l && r) { l.hidden = true; r.hidden = false; }
  }
  // Country / province selectors (uses data-provinces from all_country_option_tags)
  $$('[data-address-country-select]').forEach(function (countrySelect) {
    var provinceSelect = document.getElementById(countrySelect.getAttribute('data-province-select'));
    if (!provinceSelect) return;
    var wrap = provinceSelect.closest('.field');
    function populate() {
      var opt = countrySelect.options[countrySelect.selectedIndex];
      var provinces = [];
      try { provinces = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (err) {}
      provinceSelect.innerHTML = '';
      if (!provinces.length) { if (wrap) wrap.hidden = true; return; }
      if (wrap) wrap.hidden = false;
      var def = provinceSelect.getAttribute('data-default');
      provinces.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p[0]; o.textContent = p[1];
        if (p[0] === def) o.selected = true;
        provinceSelect.appendChild(o);
      });
    }
    var defaultCountry = countrySelect.getAttribute('data-default');
    if (defaultCountry) {
      Array.prototype.some.call(countrySelect.options, function (o) { if (o.value === defaultCountry || o.textContent === defaultCountry) { o.selected = true; return true; } });
    }
    countrySelect.addEventListener('change', populate);
    populate();
  });

  /* Shopify theme editor hooks --------------------------------------------- */
  document.addEventListener('shopify:section:load', function () { registerDrawers(); });
  document.addEventListener('shopify:section:select', function (e) {
    var drawerEl = e.target.querySelector && e.target.querySelector('[data-drawer]');
    if (drawerEl && drawers[drawerEl.getAttribute('data-drawer')] && drawerEl.getAttribute('data-drawer') === 'cart') drawers.cart.open();
  });
  document.addEventListener('shopify:section:deselect', function () { openStack.slice().forEach(function (d) { d.close(); }); });
})();
